(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/overview/overview.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/overview/overview.js');
"use strict";



const {
  Modal
} = svs.components.react_modal;
const {
  ReactIcon
} = svs.ui;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  OverviewRow,
  actions
} = svs.challenge;
const {
  useRef,
  useEffect
} = React;
const Overview = _ref => {
  let {
    draw,
    drawEvents,
    rowPrice,
    betSum
  } = _ref;
  const dispatch = useDispatch();
  function handleCloseOverview() {
    dispatch(actions.closeOverview());
  }
  const rows = draw.drawEvents.map(event => React.createElement(OverviewRow, {
    couponEvent: drawEvents[event.eventNumber],
    event: event,
    key: event.eventNumber
  }));
  const isOverviewOpen = useSelector(state => state.isOverviewOpen);
  const folderRef = useRef();
  useEffect(() => {
    if (svs.core.detect.formfactor.desktop()) {
      if (isOverviewOpen) {
        folderRef.current.classList.add('challenge-slider-folder-open');
      } else {
        folderRef.current.classList.remove('challenge-slider-folder-open');
      }
    }
  }, [isOverviewOpen]);
  if (svs.core.detect.formfactor.mobile()) {
    return React.createElement(Modal, {
      buttonClassName: "inverted",
      headerClass: "challenge-modal-header",
      onRightButtonClick: handleCloseOverview,
      rightButton: true,
      rightButtonText: "st\xE4ng",
      show: isOverviewOpen,
      title: "\xD6versikt av spelet"
    }, React.createElement(svs.components.ReactSwiper, null, React.createElement("div", {
      className: "padding"
    }, React.createElement("div", {
      className: "margin-bottom-1"
    }, rows), React.createElement("div", {
      className: ""
    }, React.createElement(svs.challenge.SignSeparators, {
      drawEvents: drawEvents,
      rowPrice: rowPrice
    }), React.createElement("div", {
      className: "right f-200 f-bold"
    }, svs.utils.format.Currency(betSum), ' ', "kr")))));
  }
  return React.createElement("div", {
    className: "challenge-slider-folder",
    ref: folderRef
  }, React.createElement(svs.components.ReactSwiper, null, React.createElement("div", {
    className: "grid-row padding-1"
  }, React.createElement("button", {
    className: "icon-button right",
    onClick: handleCloseOverview,
    type: "button"
  }, React.createElement(ReactIcon, {
    className: "pointer",
    icon: "close",
    size: "100"
  }))), React.createElement("div", {
    className: "padding"
  }, React.createElement("div", {
    className: "margin-bottom-1"
  }, rows), React.createElement("div", null, React.createElement(svs.challenge.SignSeparators, {
    drawEvents: drawEvents,
    rowPrice: rowPrice
  }), React.createElement("div", {
    className: "right f-200 f-bold"
  }, svs.utils.format.Currency(betSum), ' ', "kr")))));
};
svs.challenge.Overview = Overview;

 })(window);